import { useEffect } from "react";
import "./App.css";
import Head from "./Header";
function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <Head /> */}
      <div className="container main-container" style={{ marginTop: 150 }}>
        <div className="row">
          <div className="col-12">
            <h1 className="policy-head heading-font">Terms & Conditions</h1>

            <p>
              Welcome to Raya Creations! By downloading, installing, or using
              our app, you agree to be bound by the following Terms and
              Conditions. Please read them carefully.
            </p>

            <b>1. Acceptance of Terms</b>

            <p>
              By accessing or using Raya Creations, you agree to comply with
              these Terms. If you do not agree, please do not use the app.
            </p>

            <b>2. Eligibility</b>

            <p>
              You must be at least 18 years old to use this app. By using Raya
              Creations, you confirm that you meet this requirement.
            </p>
            <b>3.User Accounts</b>
            <p>
              You are responsible for maintaining the confidentiality of your
              account credentials. &bull; Raya Creations reserves the right to
              suspend or terminate accounts for any unauthorized or fraudulent
              activity.
            </p>

            <b>4. Content Ownership and Copyright</b>
            <p>
              Content created and uploaded by users remains their property.
              However, by uploading content, you grant us a non-exclusive,
              royalty-free license to display, distribute, and promote your
              content. &bull; You must not upload any copyrighted material
              without the proper permissions.
            </p>

            <b>5. Prohibited Activities</b>

            <p>
              Users must not: &bull; Post content that is offensive, illegal, or
              harmful. &bull; Engage in activities that harm the app&rsquo;s
              security or functionality.
            </p>

            <b>6. Limitation of Liability</b>

            <p>
              Raya Creations is not responsible for any damages or losses
              arising from the use of the app.
            </p>

            <b>7. Changes to Terms</b>

            <p>
              We reserve the right to modify these Terms at any time. Continued
              use of the app constitutes your acceptance of the revised Terms.
            </p>

            <b>8. Contact Information</b>

            <p>
              For any questions or concerns regarding these Terms, please
              contact us at: contact@rayacreations.com
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
export default Terms;
